export type SurveyName =
  | 'dataCaptureSurvey'
  | 'auroraForLineItemsSurvey'
  | 'fieldsToCaptureRedesignSurvey'
  | 'formulaFieldsSurvey'
  | 'fieldManagerSurvey'
  | 'discoveryCallSurvey'
  | 'featureFeedbackSurvey';

export const surveysUuidMap: Record<SurveyName, string> = {
  dataCaptureSurvey: '1e90b867-8bcd-4fce-be37-9b3b0fa6dacd',
  auroraForLineItemsSurvey: '533d578c-8432-46fe-8117-d07baf6f68bc',
  fieldsToCaptureRedesignSurvey: 'd549aa88-9b5b-4e4a-9906-74e11435de63',
  formulaFieldsSurvey: 'c71ee934-543b-4605-95c3-0bd5e3f257ff',
  fieldManagerSurvey: '1214d95c-9259-4378-8ab1-1e6f6352080a',
  discoveryCallSurvey: '1728f575-fe98-4e72-a429-6b0f82d36b89',
  featureFeedbackSurvey: 'e602a6c2-3e94-4c7e-ae02-f91ba91a4751',

  // not used anymore
  // unifiedDashboardSurvey: '36b5b99e-d1ba-432c-967e-87e9732695d4',
};
